import React, { Suspense } from 'react';
import { WithStorage, WithSuspense } from './ui';
import { useOnceSearchParams } from './lib';
import { getWebStorage } from './lib';
import './style.css';
const PtCardWrap = ({ children }) => {
  return (
    <div className='container-doc container-guide'>
      <div className='content-article' role='article'>
        {children}
      </div>
    </div>
  );
};

const PtCard = () => {
  const { hspId, mpiKey } = useOnceSearchParams();


  // const [invalidReferrer] = useCheckReferrer([process.env.REACT_APP_API_DFD_SVC_URL]);
  // if (invalidReferrer) return <div></div>;

  const { session } = getWebStorage();

  if (session) {
    return (
      <PtCardWrap>
        <WithStorage session={session} />
      </PtCardWrap>
    );
  }

  // 임시 에러 처리
  if (!(hspId || mpiKey))
    return (
      <div className='err-ptcard-susp'>
        잘못된 접근 방식입니다 <br /> 찾으시는 페이지가 존재하지 않습니다
      </div>
    );

  return (
    <PtCardWrap>
      <Suspense>
        <WithSuspense hspId={hspId} mpiKey={mpiKey} />
      </Suspense>
    </PtCardWrap>
  );
};

export default PtCard;
